export const menuData = [
  { title: "Statistics", link: "statistics" },
  { title: "Projects", link: "projects" },
  { title: "Contacts", link: "contacts" },
  { title: "About us", link: "aboutus" },
  { title: "Team", link: "team" },
];
